import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { LoadScript } from "@react-google-maps/api";
import "./shared/global.css";
import "./shared/override.css";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "redux/store";
import { client } from "helper/apolloConfig";
import { ApolloProvider } from "@apollo/client";
import { googleMapsApiKey } from "config/index";
import * as Sentry from "@sentry/react";

// Initialize Sentry for error tracking
Sentry.init({
  dsn: "https://8eb6f9f1f88bd78de8d87eaa3c98cf4c@o4510473291628544.ingest.us.sentry.io/4510473413197824",

  // Set environment based on hostname
  environment: window.location.hostname === "localhost" ? "development" : "production",

  // Integrations
  integrations: [
    // Browser tracing for performance monitoring
    Sentry.browserTracingIntegration(),
    // Replay integration for session replay (optional)
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],

  // Performance Monitoring
  tracesSampleRate: window.location.hostname === "localhost" ? 1.0 : 0.1, // 100% in dev, 10% in prod

  // Session Replay
  replaysSessionSampleRate: 0.1, // 10% of sessions
  replaysOnErrorSampleRate: 1.0, // 100% of sessions with errors

  // Enable debug mode in development
  debug: window.location.hostname === "localhost",

  // Before send hook
  beforeSend(event, hint) {
    // Log errors in development
    if (window.location.hostname === "localhost") {
      console.log("📤 Sending error to Sentry:", event.exception?.values?.[0]?.value);
    }
    return event;
  },
});

const rootDiv = document.getElementById("root");
const root = ReactDOM.createRoot(rootDiv);
root.render(
  <ApolloProvider client={client}>
    <LoadScript libraries={["places"]} googleMapsApiKey={googleMapsApiKey}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </Provider>
    </LoadScript>
  </ApolloProvider>
);
reportWebVitals();
